<template>
  <div class="body">
    <div class="notification-container">
      <div class="empty-div"></div>
      <div class="sys-msg" @click="onNotification">
        <div class="left-msg">
          <div class="avatar-container">
            <icon-svg icon-class="kefu" class="kefu-icon"></icon-svg>
          </div>
          <div class="name">吾同小客服</div>
        </div>
        <div class="right-msg" v-if="unreadCount">
          <div class="count-txt">{{unreadCount}}</div>
        </div>
      </div>
      <div class="notification-list-container">
        <list v-model="dataLoading"
              :finished="dataLoadingFinished"
              finished-text="没有更多了"
              @load="loadNotificationList"
        >
          <notification-list :dataList="dataList"></notification-list>
        </list>
      </div>
    </div>
  </div>
</template>

<script>
  import {Toast, List} from "vant"
  import NotificationList from "./NotificationList";

  export default {
    name: "NotificationPage",
    components: {
      NotificationList, Toast, List
    },
    data() {
      return {
        dataList: [],
        offset: 0,
        count: 10,

        dataLoading: true,
        dataLoadingFinished: false,
        unreadCount: 0,
      }
    },

    mounted() {
      this.loadNotificationList()
      this.GetFeedbackUnreadCount()
    },
    methods: {
      async loadNotificationList() {
        let params = {
          offset: this.offset,
          count: this.count,
        }
        this.dataLoading = true
        await this.$store.dispatch("GetNotificationList", params).then((data) => {
          if (data.code === 0) {
            this.dataList.push(...data.data)
            this.offset = data.extra.max_cursor
            if (!data.extra.has_more) {
              this.dataLoadingFinished = true
            }
          } else if (data.code === 20010) {
            this.dataLoadingFinished = true
          }
        }, () => {
          Toast("网络异常")
          this.dataLoadingFinished = true
        });
        this.dataLoading = false
      },

      GetFeedbackUnreadCount() {
        this.$store.dispatch("GetFeedbackUnreadCount").then(data => {
          if (data.code === 0) {
            this.unreadCount = data.data.count
          }
        }, () => {
        })
      },

      onNotification() {
        this.$router.push("/message")
      }
    },
  };
</script>

<style lang="scss" scoped>

  .body {
    background: #f2f2f2;
    min-height: 100vh;
  }

  .notification-container {
    .empty-div {
      height: 3px;
    }

    .sys-msg {
      margin-top: 5px;
      padding: 14px 8px;
      background: white;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left-msg {
        display: flex;
        align-items: center;
      }

      .avatar-container {
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        overflow: hidden;
        width: 45px;
        height: 45px;
        background: #f2f2f2;
        display: flex;
        align-items: center;
        justify-content: center;

        .kefu-icon{
          font-size: 28px;
          color: #fc9153;
        }
      }

      .name {
        font-size: 18px;
        font-weight: bold;
        margin-left: 14px;
      }

      .right-msg {
        width: 22px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        background: red;

        .count-txt {
          font-size: 12px;
          color: white;
        }
      }
    }

    .notification-list-container {
      margin-top: 8px;
      padding-bottom: 54px;
    }
  }
</style>
